module.exports = __webpack_public_path__ + "static/media/location.dab3b810.svg";